// Labels are keys in the "site" translation namespace.
export const NAV_LINKS = [
  { href: "#why", label: "nav.why" },
  { href: "#journey", label: "nav.journey" },
  { href: "#experience", label: "nav.experience" },
  { href: "#islamic", label: "nav.islamic" },
  { href: "#safety", label: "nav.safety" },
  { href: "#faq", label: "nav.faq" },
];

export const STORE_LINKS = {
  apple: "https://apps.apple.com/us/app/mjmarry/id6479207906",
  play: "https://play.google.com/store/apps/details?id=com.iahtasham.mjmarry",
};

export const SOCIAL_LINKS = [
  { name: "facebook", label: "footer.facebook", href: "https://www.facebook.com/muslims.j.marry" },
  { name: "instagram", label: "footer.instagram", href: "https://www.instagram.com/mjmarry_official" },
];
